import { render, staticRenderFns } from "./ListOfRegistrationRelationship.vue?vue&type=template&id=ed63f828&scoped=true"
import script from "./ListOfRegistrationRelationship.vue?vue&type=script&lang=js"
export * from "./ListOfRegistrationRelationship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed63f828",
  null
  
)

export default component.exports